import axios from "axios";
import { fetchData } from "../common/api-service";

// Dashboard APIs
export const getCount = () => fetchData("dashboard/count", "count");
export const getpurpose = () =>
  fetchData("dashboard/purpose_based_count", "purpose based count");
export const getentryBased = () =>
  fetchData("dashboard/entry_based_count", "entry based count");
export const getoverstaycount = () =>
  fetchData("dashboard/overstayed_count", "overstay count");
export const getCourierCount = () =>
  fetchData("dashboard/courier_status_based_count", "courier count");
export const getregistCount = () =>
  fetchData("dashboard/meeting_based_count", "registration count");
export const getMonthlyCount = () =>
  fetchData("dashboard/monthly/web", "monthly count");
export const gettodayCount = () => fetchData("dashboard/today", "today count");
export const getAverageApi = () =>
  fetchData("dashboard/average_gate_in", "average gate in");

// Visitor Dashboard APIs
export const getLiveCountApi = () =>
  fetchData("visitor_dashboard/live_count", "live count");
export const getHistoryCountApi = () =>
  fetchData("visitor_dashboard/history", "history");
export const getEntryCountApi = () =>
  fetchData("visitor_dashboard/entry_based", "entry based data");
export const getRegistrationCountApi = () =>
  fetchData("visitor_dashboard/registration_based", "registration data");
export const getLocationCountApi = () =>
  fetchData("visitor_dashboard/location_based", "location data");
export const getGateCountApi = () =>
  fetchData("visitor_dashboard/gate_based", "gate data");
export const getDepartmentCountApi = () =>
  fetchData("visitor_dashboard/department_based", "department data");
export const getOrganizationCountApi = () =>
  fetchData("visitor_dashboard/organization_based", "organization data");
export const getPurposeCountApi = () =>
  fetchData("visitor_dashboard/purpose_based", "purpose data");
export const getMeetingPersonCountApi = () =>
  fetchData("visitor_dashboard/meeting_person_based", "meeting person data");
